var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-select',_vm._b({staticClass:"cp-select-hotel-label",attrs:{"value":_vm.value,"loading":_vm.loading,"placeholder":_vm.placeholder},on:{"input":_vm.onInput}},'el-select',_vm.$attrs,false),_vm._l((_vm.rows),function(it,index){return _c('el-option',{key:index,attrs:{"label":it.name,"value":it.id}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }